import React, { Component } from 'react'
import styled from 'styled-components'
import AdvertSignWrapper from './AdvertSignWrapper'
import SashecAdvert from './SashecAdvert'
import { SIZES } from '../../../constants'
import Cookie from '../../../components/utils/Cookie'

const TopBanner = styled.div`
  width: 1180px;
  height: auto;
  display: block;
  position: relative;
  margin: 0 auto;
  text-align: center;

  & .banner {
    width: auto;
    max-width: 1180px;
    display: inline-block !important;
    position: relative;
    text-align: center;
    }
 
  @media screen and (max-width: ${SIZES.BREAKPOINT_MD - 1}px) {
    width: 100%;
    margin: 15px auto;

    .banner {
      max-width: 100%;
    }
  }
  
  @media screen and (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    margin-bottom: 10px;
  }
`

export default class LeaderBoard extends Component {
  shouldComponentUpdate () {
    return false
  }

  render () {
    const {
      widget: {
        meta: {
          targetId,
          size
        }
      }
    } = this.props

    const cookie = new Cookie()

    return (
      <TopBanner className='top-banner'>
        <div className="banner">
          <AdvertSignWrapper/>
          <SashecAdvert id={targetId} size={size} async={!cookie.isSet('ecoadb')}/>
        </div>
      </TopBanner>
    )
  }
}
